import React from "react";

import { ListStyled, MainIcon } from "../../theme";
import { getTranslation } from "../languageProvider";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { DateTimeFormatTimezone } from "../shared/utility";

export const PointDetail = ({
  point,
  isActive,
  Add,
  Edit,
  Delete,
  Remove,
  Select,
  selectedRoute,
}) => {
  const editHandler = () => Edit && Edit(point);
  const deleteHandler = () => Delete && Delete(point.id);
  const selectHandler = () => Select && Select(point);
  const addHandler = () => Add && Add(selectedRoute, point);
  const removeHandler = () => Remove && Remove(point);
  return (
    <ListStyled isActive={isActive} equipment>
      <MainIcon color={point.equipment.state.color}>
        <img src={point.equipment.icon} alt={point.equipment.serialNumber} />
      </MainIcon>
      <div className="detail" onClick={selectHandler}>
        <div>
          {point.equipment.serialNumber}
          <span className={`${!point.client && "error"}`} data-translate="0153">
            {" "}
            -{" "}
            {point.equipment.client
              ? point.equipment.client.name
              : getTranslation("0153")}
          </span>
        </div>
        <span data-translate="0029">
          <b data-translate="0026">{getTranslation("0026")}:</b>
          {point.started
            ? DateTimeFormatTimezone(point.started)
            : getTranslation("0029")}
        </span>
        <span data-translate="0028,0029">
          <b data-translate="0026">{getTranslation("0027")}:</b>
          {point.ended
            ? DateTimeFormatTimezone(point.ended)
            : point.started
            ? getTranslation("0028")
            : getTranslation("0029")}
        </span>
      </div>
      {Remove && (
        <span className="remove" onClick={removeHandler}>
          <RemoveOutlinedIcon />
        </span>
      )}
      {Add && (
        <span
          className={`${point.started ? "add" : "delete"}`}
          onClick={addHandler}
        >
          <AddOutlinedIcon />
        </span>
      )}
      {Edit && (
        <span className="edit" onClick={editHandler}>
          <EditOutlinedIcon />
        </span>
      )}
      {Delete && (
        <span className="delete" onClick={deleteHandler}>
          <DeleteOutlineOutlinedIcon />
        </span>
      )}
    </ListStyled>
  );
};
